module.exports = __webpack_public_path__ + "img/news-image7.85a7d04e.png";